import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, err: null };
    }
    static getDerivedStateFromError(err) {
        return { hasError: true, err };
    }
    componentDidCatch(err, info) {
        // log only — no external sink
        console.error("APIB UI error:", err, info);
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="min-h-screen bg-void text-ghost flex items-center justify-center scanlines px-6" data-testid="error-boundary">
                <div className="max-w-xl w-full border border-border bg-black/60 backdrop-blur-xl">
                    <div className="px-4 py-2 border-b border-border bg-black/40 flex items-center justify-between">
                        <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-signal">apib://signal_lost</span>
                        <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-muted">err.boundary</span>
                    </div>
                    <div className="p-8 text-center">
                        <div className="font-display text-4xl font-black uppercase tracking-tighter glow-amber text-signal">Signal Lost.</div>
                        <p className="mt-4 font-mono text-sm text-muted">An unexpected interruption was detected in the backbone. Re-establishing the link will return you to the autonomous fabric.</p>
                        <button
                            onClick={() => window.location.assign("/")}
                            className="mt-8 px-5 py-3 bg-signal text-void font-mono uppercase tracking-[0.2em] text-xs hover:bg-signal-soft"
                        >
                            Re-initiate handshake
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
